import { makeStyles } from '@/styles/theme/tss-react';

const useStyles = makeStyles({
  name: 'BlogHero',
})(({ brandColors, spacing, aspectRatio, typography }) => ({
  blogHero: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(1),
    width: '100%',
    marginTop: spacing(1),
  },
  subtitle: {
    color: brandColors.tintsNeutral20,
  },
  image: {
    aspectRatio: aspectRatio['16/9'],
    maxWidth: '100%',
    borderRadius: typography.pxToRem(16),
    overflow: 'hidden',
    objectFit: 'cover',
  },
  videoPlayer: {
    aspectRatio: aspectRatio['16/9'],
    maxWidth: '100%',
    objectFit: 'cover',
    borderRadius: typography.pxToRem(16),
    overflow: 'hidden',
  },
}));

export default useStyles;
